// extracted by mini-css-extract-plugin
export default {"main-popup__tabs":"lGcoB","main-popup__description":"rvc2j","main-popup__title":"pTuyi","main-popup__picture":"q01dq"};